export enum MissingEntityType {
  AREA_NOT_FOUND,
  AREA_NO_MATCHES,
  ATTACHMENT_DRAG_AND_DROP_ITEM,
  ATTACHMENT_DRAG_AND_DROP_WORK_ORDER,
  ATTACHMENT_NOT_FOUND,
  ATTACHMENT_NO_MATCHES,
  ATTACHMENT_NOT_ADDED,
  ITEM_NOT_FOUND,
  ITEM_NO_MATCHES,
  ITEM_NO_RELATED_ACTIONS,
  ISSUE_NOT_FOUND,
  ISSUE_NO_MATCHES,
  LAYOUT_NOT_FOUND,
  LAYOUT_NO_MATCHES,
  LOCATION_NOT_FOUND,
  LOCATION_NO_MATCHES,
  MODEL_NOT_FOUND,
  MODEL_NO_MATCHES,
  NO_ATTRIBUTES,
  NO_ISSUES_RAISED,
  NO_ISSUE_COMMENTS,
  NO_PERFORMED_WORK_COMMENTS,
  NO_WORK_ORDER_COMMENTS,
  NO_WORK_ISSUES,
  NO_WORK_ITEMS,
  NOTIFICATION_NOT_FOUND,
  PERFORMED_WORK_NOT_FOUND,
  PERFORMED_WORK_NO_MATCHES,
  PHOTO_NOT_FOUND,
  TODO_NOT_FOUND,
  UNSUBMITTED_WORK_NOT_FOUND,
  UNSUBMITTED_WORK_NO_MATCHES,
  WORK_ORDER_NOT_ASSIGNED,
  WORK_ORDER_NOT_CREATED,
  WORK_ORDER_NOT_FOUND,
  WORK_ORDER_NO_MATCHES,
  WORK_ORDER_NO_SUITABLE_MATCHES,
  WORK_ORDER_NOT_OPEN,
  WORKSPACE_NOT_FOUND,
  WORKSPACE_NOT_FOUND_HOME,
  WORKSPACE_NO_MATCHES,
  ZONE_NOT_FOUND,
  ZONE_NO_MATCHES,
}

export enum ContextAction {
  ADD_ATTACHMENT,
  ADD_TO_WORKORDER,
  ASSOCIATE_IDENTIFIER,
  CHANGE_REQUEST,
  CLONE_ITEM,
  CLOSE_ISSUE,
  CREATE_ITEM,
  CREATE_LOCATION,
  CREATE_MODEL,
  CREATE_WORK_ORDER,
  CLOSE_WORK_ORDER,
  DELETE,
  DISCARD,
  DISCARD_WORK,
  EXPORT_RESULTS,
  FEEDBACK,
  HANDLE_IDENTIFIERS,
  HELP,
  HISTORY,
  ISSUES,
  MARK_ALL_READ,
  MARK_ALL_UNREAD,
  PERFORM_ADHOC_WORK,
  PERFORM_CORRECTIVE_WORK,
  RAISE_ISSUE,
  DELETE_ISSUE,
  REJECT_ISSUE,
  REMOVE_FROM_WORKORDER,
  REMOVE_LOCATION,
  REPLACE_ITEM,
  SUPERSEDE_ISSUE,
  SUPPORT,
  TAKE_PHOTO,
  TOGGLE_DISPLAY_PERFORMED_ON,
  TOGGLE_DISPLAY_PERFORMED_OFF,
  USER_SETTINGS,
  IMAGE_ZOOM_IN,
  IMAGE_ZOOM_OUT,
}

export enum MainMenuType {
  WORKSPACES,
  SETTINGS,
  ATTACHMENTS,
  ZONES,
  LAYOUTS,
  AREAS,
  LOCATIONS,
  MODELS,
  ITEMS,
  PERFORMED_WORK,
  ISSUES,
  HOME,
  ANALYTICS,
  WORK_ORDERS,
  ADMINISTRATION,
  AUDIT,
  IDENTIFY,
  CHANGE_REQUESTS,
  WORK_DOMAINS,
}
